import React from "react";

function StudentBioData({studentProfile, pocketMoneyLimit, fingerprintStatus, enrollmentDate, authumNo, faceStatus, termlyFeeStatus}) {

    return (
        <table className="table mb-0 mw-100 color-span">
            {studentProfile && (
                <tbody>
                    <tr>
                        <td className="py-2 px-0">{" "}
                            <span className="w-50">
                                Names{" "}
                            </span>{" "}
                        </td>
                        <td>:</td>
                        <td className="py-2 px-0">{" "}
                            <span className="">
                                {studentProfile.full_name}
                            </span>{" "}
                        </td>
                    </tr>

                    <tr>
                        <td className="py-2 px-0">{" "}
                            <span className="w-50">
                                Student Code
                            </span>{" "}
                        </td>
                        <td>:</td>
                        <td className="py-2 px-0">{" "}
                            <span className="">
                                {studentProfile.username}
                            </span>{" "}
                        </td>
                    </tr>

                    <tr>
                        <td className="py-2 px-0">{" "}
                            <span className="w-50">
                                Authum Reg.No
                            </span>{" "}
                        </td>
                        <td>:</td>
                        <td className="py-2 px-0">{" "}
                            <span className="">
                                {!authumNo
                                ? "N/A"
                                : authumNo}
                            </span>{" "}
                        </td>
                    </tr>

                    <tr>
                        <td className="py-2 px-0">{" "}
                            <span className="w-50">
                                Group Name
                            </span>{" "}
                        </td>
                        <td>:</td>
                        <td className="py-2 px-0">{" "}
                            <span className="">
                                {studentProfile.group}
                            </span>{" "}
                        </td>
                    </tr>

                    <tr>
                        <td className="py-2 px-0">{" "}
                            <span className="w-50">
                                School Name
                            </span>{" "}
                        </td>
                        <td>:</td>
                        <td className="py-2 px-0">{" "}
                            <span className="">
                                {studentProfile.school}
                            </span>{" "}
                        </td>
                    </tr>

                    <tr>
                        <td className="py-2 px-0">{" "}
                            <span className="w-50">
                                Activation Status | Default Pin
                            </span>
                        </td>
                        <td>:</td>
                        <td className="py-2 px-0">{" "}
                        <span className="">
                            {studentProfile.is_activated ==="0"
                                ? <span class="badge badge-danger">NOT ACTIVATED </span>
                                : <span class="badge badge-success">ACTIVATED </span>} {" "}
                                | {studentProfile.is_secure=== 1? <span class="badge badge-success">SECURED</span>: <span class="badge badge-danger">{studentProfile.default_pin}</span>}
                            </span> 
                        </td>
                    </tr>

                    <tr>
                        <td className="py-2 px-0">{" "}
                            <span className="w-50">
                                {studentProfile.card_info?.type === "CARD"? "Card" : 
                                studentProfile.card_info?.type === "WRISTBAND"? "Wristband" : "Card/Wristband"}{" "}
                                
                               Status
                            </span>{" "}
                        </td>
                        <td>:</td>
                        <td className="py-2 px-0">{" "}
                            <span className="">
                            {studentProfile.card_status ==="2"? <span class="badge badge-danger">DEACTIVATED - {studentProfile.card_number}</span>
                                :studentProfile.card_status ==="1"? <span class="badge badge-success">ASSIGNED - {studentProfile.card_number}</span>
                                : <span class="badge badge-warning">UNASSIGNED</span>}{" "}{studentProfile.card_info?.type === "CARD"? <img 
        src={
            process.env.PUBLIC_URL +
            "/assets/img/figure/id-card.png"
          } 
          alt="App User" 
          style={{ width: '16px', height: '18px', marginLeft: '2px'}} 
        /> : 
                                studentProfile.card_info?.type === "WRISTBAND"? <img 
        src={
            process.env.PUBLIC_URL +
            "/assets/img/figure/smart.png"
          } 
          alt="App User" 
          style={{ width: '18px', height: '20px', marginLeft: '2px'}} 
        /> : ""}
                            </span>{" "}
                        </td>
                    </tr>
                    <tr>
                        <td className="py-2 px-0">{" "}
                            <span className="w-50">
                                Face ID Status
                            </span>
                        </td>
                        <td>:</td>
                        <td className="py-2 px-0">{" "}
                        <span className="">
                            {faceStatus?.face_status === "1"
                                ? <span class="badge badge-success">ENROLLED </span>
                                : <span class="badge badge-danger">NOT ENROLLED </span>} {" "}<br/>
                            {faceStatus?.face_status === "1"?<small className="text-muted">Enrolled on {faceStatus?.face_enrollment_date?.long_date}</small>:""}
                                
                            </span> 
                        </td>
                    </tr>
                    <tr>
                        <td className="py-2 px-0">{" "}
                            <span className="w-50">
                                Fingerprint Status
                            </span>
                        </td>
                        <td>:</td>
                        <td className="py-2 px-0">{" "}
                        <span className="">
                            {!fingerprintStatus
                                ? <span class="badge badge-danger">NOT ENROLLED </span>
                                : <span class="badge badge-success">ENROLLED </span>} {" "}<br/>
                            {fingerprintStatus?<small className="text-muted">Enrolled on {enrollmentDate?.long_date}</small>:""}
                                
                            </span> 
                        </td>
                    </tr>

                     <tr>
                        <td className="py-2 px-0">{" "}
                            <span className="w-50">
                                Account Status
                            </span>
                        </td>
                        <td>:</td>
                        <td className="py-2 px-0">{" "}
                        <span className="">
                            {studentProfile.is_active ==="0"
                                ? <span class="badge badge-danger">BLOCKED </span>
                                : <span class="badge badge-success">ACTIVE </span>} {" "}
                                
                            </span> 
                        </td>
                    </tr>
                    <tr>
                        <td className="py-2 px-0">{" "}
                            <span className="w-50">
                                Termly Fee Status
                            </span>
                        </td>
                        <td>:</td>
                        <td className="py-2 px-0">{" "}
                        <span className="">
                            {termlyFeeStatus ==="NOT CLEARED"
                                ? <span class="badge badge-danger">{termlyFeeStatus} </span>
                                : <span class="badge badge-success">{termlyFeeStatus} </span>} {" "}
                                
                            </span> 
                        </td>
                    </tr>
                    <tr>
                        <td className="py-2 px-0">{" "}
                            <span className="w-50">
                                Can Make Calls{" "}
                            </span>{" "}
                        </td>
                        <td>:</td>
                        <td className="py-2 px-0">{" "}
                            <span className="">
                            {studentProfile.is_call_restricted ==="1"
                                ? <span class="badge badge-danger">BLOCKED</span>
                                : <span class="badge badge-success">ALLOWED</span>}
                            </span>{" "}
                        </td>
                    </tr>
                    <tr>
                        <td className="py-2 px-0">{" "}
                            <span className="w-50">
                                Restricted Mode
                            </span>{" "}
                        </td>
                        <td>:</td>
                        <td className="py-2 px-0">{" "}
                            <span className="">
                            {studentProfile.is_restricted ==="Restricted"
                                ? <span class="badge badge-danger">RESTRICTED</span>
                                : <span class="badge badge-success">UNRESTRICTED</span>}
                            </span>{" "}
                        </td>
                    </tr>
                    <tr>
                        <td className="py-2 px-0">{" "}
                            <span className="w-50">
                                Pocket Money Limit
                            </span>{" "}
                        </td>
                        <td>:</td>
                        <td className="py-2 px-0">{" "}
                            <span className="">
                            UGX. {pocketMoneyLimit? pocketMoneyLimit.amount:"0"} 
                            </span> <small>({pocketMoneyLimit?pocketMoneyLimit.limit_validity:""})</small><br/>
                            {pocketMoneyLimit?<small className="text-muted">Set by {pocketMoneyLimit.updated_by} on {pocketMoneyLimit.updated_at}</small>:""}
                        </td>
                    </tr>
                    <tr>
                        <td className="py-2 px-0">{" "}
                            <span className="w-50">
                                Registration Date
                            </span>{" "}
                        </td>
                        <td>:</td>
                        <td className="py-2 px-0">{" "}
                            <span className="">
                                {studentProfile.registered_on.long_date}<br/>
                            <small className="text-muted">Registered by {studentProfile.registered_by}</small>
                            </span>{" "}
                        </td>
                    </tr>

                    {studentProfile.is_activated ==="1"?<tr>
                        <td className="py-2 px-0">
                            <span className="w-50">
                                Activation Date
                            </span>
                        </td>
                        <td>:</td>
                        <td className="py-2 px-0">{" "}
                            <span className="">
                                {studentProfile.activated_on? studentProfile.activated_on.long_date: "N/A"}<br/>
                            <small className="text-muted">Activated by {studentProfile.activated_by? studentProfile.activated_by: "N/A"}</small>
                            </span>
                        </td>
                    </tr>:""}
                   
                </tbody>
            )}
        </table>  
    );
}

export default StudentBioData;
